import { graphql } from 'msw'
import { products } from './data'

function includesSearchExpression(value, searchExpression) {
  return value.toLowerCase().includes(searchExpression.toLowerCase())
}

function filterProductsBySearchExpression(products, searchExpression) {
  return products.filter(
    ({ cmsId, name }) =>
      includesSearchExpression(cmsId, searchExpression) ||
      includesSearchExpression(name, searchExpression)
  )
}

const productsHandlers = [
  graphql.query('products', (req, res, ctx) => {
    const { searchExpression, first, after } = req.variables

    const filteredProducts = searchExpression
      ? filterProductsBySearchExpression(products, searchExpression)
      : products

    const isFilteredProductsEmpty = filteredProducts.length === 0

    const pageSize = first
    const start = !after
      ? 0
      : filteredProducts.findIndex((p) => p.cmsId === after) + 1
    const end = start + pageSize
    const paginatedProducts = filteredProducts.slice(start, end)
    const endCursor = isFilteredProductsEmpty
      ? null
      : paginatedProducts[paginatedProducts.length - 1].cmsId
    const hasNextPage = end < filteredProducts.length

    return res(
      ctx.data({
        products: {
          pageInfo: {
            endCursor,
            hasNextPage,
          },
          nodes: paginatedProducts,
        },
      })
    )
  }),
]

export default productsHandlers
